module.exports = __webpack_public_path__ + "421c70655e5f3ffa3159efd517cd0831.pdf";